import httpInst from '../utilis/httpService';

const replayService = {

	getTransactionById: async (id) => {
		const http = httpInst();
		const res = await http({
				method: 'get',
				url: `/replay-api-fetch?id=${id}`,
		});
	
		console.log('res', res);
	
		return res.data;
	},

	replayTransaction: async (id) => {
		const http = httpInst();
		const res = await http({
				method: 'post',
				url: `/replay-api-call?id=${id}`,
		});
	
		return res.data;
	},

}

export default replayService;